import React, { useEffect } from "react";
import DashboardStyle from "../../app/dashboard/Styles/Dashboard.module.css";
import PageLayout from "../../app/dashboard/Components/Layout/PageLayout";
// import { FormProvider, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router";
// import { TableActionsDownload } from "../../../Components/Misc/ActionsModVersion";
import Table from "../dashboard/Components/Table/Table";
import { toast } from "react-toastify";
// import { FormTemplate } from "../dashboard/Components/Forms/InputTemplate";
import { FormatDateTime } from "../../utils/functions/ResourceFunctions";
import {
  AcceptJobOffer,
  GetJobOffer,
  RejectJobOffer,
} from "../../utils/redux/HR/HRSlice";

function ViewApplicantOffer() {
  const { id } = useParams(); // Extract `id` from the URL path
  const location = useLocation(); // Get the current location (URL)
  const [loading, setLoading] = React.useState(false); // State to manage loading status
  const [loading2, setLoading2] = React.useState(false); // State to manage loading status
  const navigate = useNavigate(); // Get the navigate function from the `react-router-dom` package

  // Function to extract query parameters
  const getQueryParam = (name) => {
    const urlParams = new URLSearchParams(location.search); // Parse query string
    return urlParams.get(name); // Get the value for the given parameter name
  };

  const url = new URL(window.location.href);
  const type = new URLSearchParams(url.search).get("type");

  const dispatch = useDispatch();
  const getRequest = useSelector((state) => state?.hr);
  const { job_offer, isLoading } = getRequest;
  const request = job_offer?.responseObject;

  useEffect(() => {
    dispatch(GetJobOffer(id));
  }, [dispatch, id]);

  // Function to convert base64 string to downloadable file
  const base64ToFile = (base64String, fileName, fileType) => {
    const byteCharacters = window.atob(base64String);
    const byteNumbers = new Array(byteCharacters.length)
      .fill()
      .map((_, i) => byteCharacters.charCodeAt(i));
    const byteArray = new Uint8Array(byteNumbers);
    const file = new Blob([byteArray], { type: fileType });
    const fileURL = URL.createObjectURL(file);
    return (
      <a
        href={fileURL}
        download={fileName}
        target="_blank"
        rel="noopener noreferrer"
      >
        {fileName}
      </a>
    );
  };

  const handleApproveByType = async () => {
    const payload = {
      applicantId: request?.id,
      comment: "Approved",
      approvalDesignation: type === "MD" ? 1 : 0,
    };

    try {
      setLoading(true);
      const actionDispatchFunction = await dispatch(AcceptJobOffer(payload));
      console.log("Action Dispatch Function:", actionDispatchFunction);
      if (actionDispatchFunction?.payload?.successful === true) {
        navigate("/");
        setLoading(false);
        toast.success(actionDispatchFunction?.payload?.statusMessage);
      } else if (actionDispatchFunction?.payload?.successful === false) {
        toast.error(actionDispatchFunction?.payload?.statusMessage);
        setLoading(false);
      }
    } catch (error) {
      console.error("Error:", error);
      setLoading(false);
    }
  };

  const handleRejectByType = async () => {
    const payload = {
      applicantId: request?.id,
      rejectionComment: "offer too small",
      approvalDesignation: type === "MD" ? 1 : 0,
    };

    try {
      setLoading2(true);
      const actionDispatchFunction = await dispatch(RejectJobOffer(payload));
      console.log("Action Dispatch Function:", actionDispatchFunction);
      if (actionDispatchFunction?.payload?.successful === true) {
        navigate("/");
        setLoading2(false);
        toast.success(actionDispatchFunction?.payload?.statusMessage);
      } else if (actionDispatchFunction?.payload?.successful === false) {
        toast.error(actionDispatchFunction?.payload?.statusMessage);
        setLoading2(false);
      }
    } catch (error) {
      console.error("Error:", error);
      setLoading2(false);
    }
  };

  return (
    <div className="max-w-7xl mx-auto my-10 p-6 bg-white border border-gray-200 rounded-lg shadow-lg">
      <PageLayout title={"Applicant Offer Letter"}>
        <section
          style={{
            backgroundColor: "#F8FBF8",
            border: "1px solid #D9E9DA",
            borderRadius: "8px",
          }}
          className={DashboardStyle.form_section}
        >
          <h4 className={DashboardStyle.form_section_title}>
            Applicant Information
          </h4>
          <div className={DashboardStyle.labels_group}>
            <div>
              <div>
                <p>First Name:</p>
                <h4>{request?.firstName}</h4>
              </div>
              <div>
                <p>Last Name:</p>
                <h4>{request?.lastName}</h4>
              </div>
              <div>
                <p>Other Name:</p>
                <h4>{request?.otherName}</h4>
              </div>
              <div>
                <p>Gender:</p>
                <h4>{request?.gender === 1 ? "Male" : "Female"}</h4>
              </div>
              <div>
                <p>Marital Status:</p>
                <h4>
                  {request?.maritalStatus === 1
                    ? "Single"
                    : request?.maritalStatus === 2
                    ? "Married"
                    : "Other"}
                </h4>
              </div>
            </div>

            <div>
              <div>
                <p>Email:</p>
                <h4>{request?.email}</h4>
              </div>
              <div>
                <p>Phone:</p>
                <h4>{request?.phone}</h4>
              </div>
              <div>
                <p>Date of Birth:</p>
                <h4>{FormatDateTime(request?.dob, "ll")}</h4>
              </div>
              <div>
                <p>Location:</p>
                <h4>{request?.location}</h4>
              </div>
              <div>
                <p>Portfolio:</p>
                <h4>{request?.portfolio}</h4>
              </div>
            </div>

            <div>
              <div>
                <p>Interview Status:</p>
                <h4>
                  {request?.interviewStatus === 1
                    ? "Pending"
                    : request?.interviewStatus === 0
                    ? "Approved"
                    : request?.interviewStatus === 7
                    ? "Declined"
                    : request?.interviewStatus === 11
                    ? "Cancelled"
                    : request?.interviewStatus === 2
                    ? "Closed"
                    : request?.interviewStatus === 5
                    ? "Selected"
                    : request?.interviewStatus === 4
                    ? "Accepted"
                    : request?.interviewStatus === 411
                    ? "All"
                    : ""}
                </h4>
              </div>
              <div>
                <p>Offer Status:</p>
                <h4>
                  {request?.offerStatus === 1
                    ? "Pending"
                    : request?.offerStatus === 0
                    ? "Approved"
                    : request?.offerStatus === 7
                    ? "Declined"
                    : request?.offerStatus === 11
                    ? "Cancelled"
                    : request?.offerStatus === 2
                    ? "Closed"
                    : request?.offerStatus === 5
                    ? "Selected"
                    : request?.offerStatus === 4
                    ? "Accepted"
                    : request?.offerStatus === 411
                    ? "All"
                    : ""}
                </h4>
              </div>
              <div>
                <p>Grade:</p>
                <h4>{request?.applicantEvaluation?.value || "NA"}</h4>
              </div>
            </div>
          </div>
        </section>

        <section className={DashboardStyle.form_section}>
          <h4 className={DashboardStyle.form_section_title}>
            Documents Uploads
          </h4>
          <div
            className={`${DashboardStyle.labels_group} ${DashboardStyle.labels_group_downloads}`}
          >
            {request?.documents?.length === 0 ? (
              <p>No Record Available</p>
            ) : (
              <Table className={DashboardStyle.table}>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>File Name</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {(request?.documents || []).map((doc, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{doc.definitionName}</td>
                      <td>
                        {base64ToFile(
                          doc?.file,
                          doc?.fileName,
                          "application/pdf"
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            )}
          </div>
        </section>

        <div className={DashboardStyle.button_cage}>
          <button
            type="button"
            onClick={handleRejectByType}
            className="px-6 py-2 bg-gray-100 text-gray-800 border border-gray-300 rounded-md"
          >
            {loading2 ? "Processing..." : "Reject"}
          </button>
          <button
            type="submit"
            // disabled={!isValid}
            onClick={() => handleApproveByType()}
            className="px-6 py-2 bg-green-600 text-white rounded-md"
          >
            {loading ? "Processing..." : "Accept"}
          </button>
        </div>
      </PageLayout>
    </div>
  );
}

export default ViewApplicantOffer;
